import InvoiceHomeDetailCard from "../invoice-homepage/InvoiceHomeDetailCard";
import { getInvoiceDetailsCardInfo } from "../invoice-master/invoice-helper";
import { RootState } from "src/context/store";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "src/hooks/useToast";
import { invoiceActions } from "src/context/invoice-slice";
import { fetchInvoicesData } from "src/services/invoice-api";
import { useEffect, useState } from "react";
import { Spinner } from "src/components";
import InfiniteScroll from "react-infinite-scroll-component";

const InvoiceApproval = () => {
  const { invoiceApprovalList } = useSelector((state: RootState) => state.invoice);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetchTabData = async () => {
    setIsLoading(true);
    try {
      let response;
      const searchParams = {
        fuid_status_id: 6,
        page_size: 10,
        page_number: 1,
      };

      response = await fetchInvoicesData(searchParams);

      dispatch(invoiceActions.setInvoiceApprovalList(response?.data?.data?.invoiceData || []));
      toast({ description: "Invoice data fetched successfully", variant: "default" });
    } catch (error) {
      console.error("Error fetching invoices data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchMoreData = async () => {
    if (isLoading) return;

    try {
      const searchParams = {
        fuid_status_id: 6,
        page_size: 10,
        page_number: page + 1,
      };
      setPage((prevPage) => prevPage + 1);
      const res = await fetchInvoicesData(searchParams);

      if (!res?.data?.data || res?.data?.data?.invoiceData?.length === 0) {
        setHasMore(false);
        return;
      }

      const uniqueNewData = res?.data?.data?.invoiceData;

      if (uniqueNewData.length === 0) {
        setHasMore(false);
        return;
      }

      dispatch(
        invoiceActions.setInvoiceApprovalList(invoiceApprovalList ? [...invoiceApprovalList, ...uniqueNewData] : res?.data?.data?.invoiceData)
      );
    } catch (error) {
      console.error("Error fetching more data:", error);
      toast({
        variant: "destructive",
        description: "Failed to load more e-invoices",
      });
      setHasMore(false);
    }
  };

  useEffect(() => {
    fetchTabData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-[50vh]">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="relative">
      {invoiceApprovalList?.length > 0 && (
        <div
          id="scrollableDiv"
          className="h-[calc(100vh-250px)] overflow-auto overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
        >
          <InfiniteScroll
            dataLength={invoiceApprovalList?.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <div className="flex justify-center py-4">
                <Spinner />
              </div>
            }
            scrollableTarget="scrollableDiv"
            endMessage={<div className="py-4 text-center text-gray-500">No more e-invoices to load</div>}
          >
            {invoiceApprovalList?.map((data: any, index: number) => (
              <li className="rounded-xl border shadow-sm border-gray-200 list-none my-4" key={index}>
                <InvoiceHomeDetailCard
                  status={data?.fileStatusHdr?.fuid_status_desc}
                  isExpandable={true}
                  isExpandedInitial={false}
                  data={getInvoiceDetailsCardInfo(data)}
                  checkDataType={false}
                  invoiceData={data}
                  viewDetails={true}
                  index={index}
                  approvalScreen={true}
                />
              </li>
            ))}
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
};

export default InvoiceApproval;
